var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"steps"},[_vm._l((_vm.steps),function(i){return [(_vm.stepOfHide.indexOf(i) == -1)?_c('div',{key:i,staticClass:"step",class:{
                'step__active': i == _vm.active,
                'step__passed': i < _vm.active
            }},[_vm._t(i)],2):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }